const app_menu = [
    {
        name: "Cocktails",
        link: "https://google.com",
        image: "/photos/david.jpg",
        allergies: [],
        description: "Cocktails curated by the Bride and Groom"
      },
      {
        name: "Beer",
        link: "https://google.com",
        image: "/photos/david.jpg",
        allergies: [],
        description: "Beer provided by Ill Mannered"
      },  {
        name: "Wine",
        link: "https://google.com",
        image: "/photos/david.jpg",
        allergies: [],
        description: "Wine selection of red/white"
      },
    {
        name: "Shrimp Cocktail",
        link: "https://google.com",
        image: "/photos/david.jpg",
        allergies: ["shellfish"],
        description: "Platter of chilled shrimp served with tangy cocktail dipping sauce."
      },
      {
        name: "Salad",
        link: "https://google.com",
        image: "/photos/david.jpg",
        allergies: [],
        description: "Fresh leafy greens with seasonal vegetables and dressings on the side."
      },
      {
        name: "Pita Chips & Hummus",
        link: "https://google.com",
        image: "/photos/david.jpg",
        allergies: ["gluten"],
        description: "Crunchy pita chips served with smooth and creamy hummus."
      },    {
        name: "California Rolls",
        link: "https://google.com",
        image: "/photos/david.jpg",
        allergies: ["shellfish"],
        description: "Classic sushi roll with imitation crab, avocado, and cucumber wrapped in seaweed and rice."
      },

  ];
  

// const dinner_menu = [{
//     name: "TBD",
//     link: "https://google.com",
//     image: "/photos/david.jpg",
//     allergies: [],
//     description: "Coming Soon!"
// },
// ]
export default app_menu